import axios from 'axios'
import * as types from '../mutation-types'

import { createTheParametersOfTheUrl } from '../../plugins/helper'

const doToArrayObject = activities => {
  const term = []
  Object.keys(activities).forEach(key => {
    term.push({
      value: activities[key].id,
      text: activities[key].nombre,
      house_id: activities[key].pivot ? activities[key].pivot.vivienda_id : null,
    })
  })

  return term
}

// state
export const state = {
  loading: true,
  activitiesByHouseId: [],
  error: null,
}

// mutations
export const mutations = {
  [types.GET_ACTIVITIES_BY_HOUSE_ID_START] (state) {
    state.loading = true
    state.activitiesByHouseId = []
    state.error = null
  },

  [types.GET_ACTIVITIES_BY_HOUSE_ID_SUCCESS] (state, { data }) {
    state.loading = false
    state.activitiesByHouseId = doToArrayObject(data)
    state.error = null
  },

  [types.GET_ACTIVITIES_BY_HOUSE_ID_ERROR] (state, { error }) {
    state.loading = false
    state.activitiesByHouseId = []
    state.error = error
  },
}

export const actions = {
  async getActivitiesByHomeId ({ commit }, { houseId, params }) {
    try {
      commit(types.GET_ACTIVITIES_BY_HOUSE_ID_START)

      const href = createTheParametersOfTheUrl(params)
      const { data } = await axios.get(`/api/activities/list_by_id_houses/${houseId}${href}`)

      commit(types.GET_ACTIVITIES_BY_HOUSE_ID_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_ACTIVITIES_BY_HOUSE_ID_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  loadingActivitiesByHouseId: state => state.loading,
  activitiesByHouseId: state => state.activitiesByHouseId,
  errorActivitiesByHouseId: state => state.error,
}
